/* eslint-disable no-undef */
export const getQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.href.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
};

export const getUrlParams = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).slice(0, -1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
};

//生成随机数
export const randomString = (len) => {
  len = len || 32;
  var $chars = "012345678";
  var maxPos = $chars.length;
  var pwd = "";
  var i = 0;
  for (i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};

export const isIos = /iphone|ipad|ipod|Mac OS/gi.test(navigator.userAgent);

export function MapLoader() {
  let aMapScript = document.createElement("script");
  aMapScript.setAttribute(
    "src",
    "https://webapi.amap.com/maps?v=1.4.11&key=c0af2a8bee25c16d7a307124ddb43056&plugin=AMap.CitySearch"
  );
  document.head.appendChild(aMapScript);
  return new Promise((resolve, reject) => {
    aMapScript.onload = function () {
      AMap.plugin("AMap.Geolocation", function () {
        var geolocation = new AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000,
          // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
          buttonOffset: new AMap.Pixel(10, 20),
          //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          zoomToAccuracy: true,
          //  定位按钮的排放位置,  RB表示右下
          buttonPosition: "RB",
        });

        geolocation.getCurrentPosition();
        AMap.event.addListener(geolocation, "complete", resolve);
        AMap.event.addListener(geolocation, "error", reject);
      });
    };
  });
}

export function getLocation() {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });
    } else {
      reject();
      alert("浏览器不支持Geolocation API");
    }
  });
}
